class User {
  constructor (newUserData = null) {
    if (newUserData != null) {
      this._saveUserDataToStorage(newUserData)
    } else {
      this._loadUserDataFromStorage()
    }
  }

  isUserAuth () {
    if (this.userAuthData != null) {
      return true
    }

    return false
  }

  logout () {
    localStorage.removeItem('user')
    localStorage.removeItem('userDataOptions')
  }

  getAccessToken () {
    if (typeof this.userAuthData !== 'undefined' && this.userAuthData !== null) {
      return this.userAuthData.access_token
    }
    return null
  }

  getLic () {
    return JSON.parse(localStorage.getItem('userDataOptions')).lic
  }

  getOptions () {
    return JSON.parse(localStorage.getItem('userDataOptions')).options
  }

  getRefreshToken () {
    return this.userAuthData.refresh_token
  }

  getTokenExpiresTime () {
    return this.userAuthData.expires_in
  }

  _saveUserDataToStorage (userData) {
    userData.createdAt = new Date().getTime()
    localStorage.setItem('user', JSON.stringify(userData))
    this.userAuthData = userData
  }

  _loadUserDataFromStorage () {
    if (localStorage.user) {
      this.userAuthData = JSON.parse(localStorage.user)
    }
  }
}

export default User



// WEBPACK FOOTER //
// ./src/models/User.js